import { GradientButton } from './gradient-button'

export const BlueGradientButton: React.FC<IGradientButton> = (props) => (
  <GradientButton gradient="blue" {...props} />
)

export default BlueGradientButton
